import React from "react";
import i18next from "i18next";
import logoMark from "../img/logo-mark.svg";

// Логотип кабинета: векторный знак + текст из i18n. В китайской сборке текст —
// 管会通活动 (как app_name в сборке мобилки), в остальных — NaviConf.
export function Logo({ textStyle }) {
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 10,
        minWidth: 0,
      }}
    >
      <img
        src={logoMark}
        alt=""
        style={{ width: 34, height: 34, flexShrink: 0 }}
      />
      <span
        style={{
          color: "#fff",
          fontWeight: 600,
          fontSize: 17,
          letterSpacing: 2,
          whiteSpace: "nowrap",
          ...textStyle,
        }}
      >
        {i18next.t("app_name")}
      </span>
    </span>
  );
}
